import { render, staticRenderFns } from "./AuthCardPhone.vue?vue&type=template&id=a4984940&scoped=true&"
import script from "./AuthCardPhone.vue?vue&type=script&lang=js&"
export * from "./AuthCardPhone.vue?vue&type=script&lang=js&"
import style0 from "./AuthCardPhone.vue?vue&type=style&index=0&id=a4984940&scoped=true&lang=css&"
import style1 from "./AuthCardPhone.vue?vue&type=style&index=1&id=a4984940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4984940",
  null
  
)

export default component.exports